/*
 * COPYRIGHT 2022,2023 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 *
 */

import { Border, BorderRadius, Colours, FontFamily, FontSize } from 'yospace-ui-components';
import { EventStatus } from '../common/EventStatus';

export class EventDataStyles {
    static STYLES = Object.freeze({
        label: {
            color: Colours.textNormal2,
            display: 'table-cell',
            fontSize: FontSize.small1,
            fontWeight: '500',
            padding: '12px 0px 12px 13px'
        },
        main: {
            backgroundColor: Colours.backgroundDark,
            padding: '13px 14px 17px 14px'
        },
        inner: {
            border: Border.normal,
            borderColor: Colours.border1,
            borderRadius: BorderRadius.medium,
        },
        metadataText: {
            display: 'table-cell',
            fontFamily: FontFamily.monospace,
            fontSize: FontSize.mediumSmall1,
            fontWeight: '400',
            padding: '0px 0px 0px 28px'
        },
        spacer: {
            padding: '0px 0px 12px 0px'
        },
        activityDateText: {
            color: Colours.textNormal2,
            fontSize: FontSize.small1,
            fontWeight: '500',
            padding: '0px 28px 0px 0px'

        },
        activityText: {
            color: Colours.textNormal,
            fontFamily: FontFamily.monospace,
            fontWeight: '400',
            fontSize: FontSize.mediumSmall1,
            lineHeight: '15px'
        },
        tableContainer: {
            overflowY: 'auto',
            maxHeight: '200px'
        }
    });

    static getInner() {
        return EventDataStyles.STYLES.inner;
    }

    static getLabel() {
        return EventDataStyles.STYLES.label;
    }

    static getMain() {
        return EventDataStyles.STYLES.main;
    }

    static getMetadataText() {
        return EventDataStyles.STYLES.metadataText;
    }

    static getSpacer() {
        return EventDataStyles.STYLES.spacer;
    }

    static getActivityDateText() {
        return EventDataStyles.STYLES.activityDateText;
    }

    static getActivityText() {
        return EventDataStyles.STYLES.activityText;
    }

    static getTableContainer() {
        return EventDataStyles.STYLES.tableContainer;
    }
}

export class StatusViewStyles {
    static STYLES = Object.freeze({
        externalLinkButton: {
            display: 'table-cell',
            fontSize: '19px',
            padding: '0px 0px 0px 12px',
        },
        externalLinkButtonRight: {
            display: 'table-cell',
            fontSize: '19px',
            padding: '0px 0px 0px 7px',
        },
        main: {
            padding: '10px 0px',
            width: "unset"
        },
        label: {
            borderRadius: BorderRadius.medium,
            display: 'table-cell',
            height: '24px'
        },
        text: {
            fontWeight: '700',
            fontSize: FontSize.small2,
            textAlign: 'center',
            lineHeight: '24px'
        }
    });

    static getLabel(type) {
        let style = Object.assign( {}, StatusViewStyles.STYLES.label );

        switch (type) {
            case EventStatus.SCHEDULED:
                style.backgroundColor = Colours.highlight8;
                style.width = '118px';
                break;

            case EventStatus.UPCOMING:
                style.backgroundColor = Colours.highlight9;
                style.minWidth = '118px';
                break;

            case EventStatus.LIVE:
                style.backgroundColor = Colours.highlight7;
                style.minWidth = "32px";
                style.verticalAlign = "middle";
                break;

            case EventStatus.PAST:
                style.backgroundColor = Colours.highlight4;
                style.minWidth = '84px';
                break;

            case EventStatus.PROVISIONING:
                style.backgroundColor = Colours.highlight10;
                style.width = '118px';
                break;

            case EventStatus.READY:
                style.backgroundColor = Colours.highlight9;
                style.width = '118px';
                break;

            default:
                style.backgroundColor = Colours.highlight8;
                style.minWidth = '118px';
        }

        return style;
    }

    static getExternalLinkButtonStyle(liveOnly) {
        return liveOnly ? StatusViewStyles.STYLES.externalLinkButtonRight : StatusViewStyles.STYLES.externalLinkButton;
    }

    static getMain() {
        return StatusViewStyles.STYLES.main;
    }

    static getText() {
        return StatusViewStyles.STYLES.text;
    }
}
